import(/* webpackMode: "eager" */ "/home/runner/work/sms-service-frontend/sms-service-frontend/src/app/(static)/terms-of-service/page.tsx")